import { Address, isThor } from "rujira.js";
import { Provider } from "rujira.ui";

type ConnectedAccount = {
  address: Address;
  provider: Provider.Key;
};

export type GroupedConnectedAccount = {
  address: Address;
  providers: Provider.Key[];
};

export const groupAccountsByAddress = (
  accounts: readonly ConnectedAccount[]
): GroupedConnectedAccount[] => {
  const grouped = new Map<string, GroupedConnectedAccount>();
  for (const { address, provider } of accounts) {
    const current = grouped.get(address.address);
    grouped.set(
      address.address,
      current
        ? {
            ...current,
            providers: current.providers.includes(provider)
              ? current.providers
              : [...current.providers, provider],
          }
        : { address, providers: [provider] }
    );
  }
  return [...grouped.values()];
};

export const groupThorAccountsByAddress = (
  accounts: readonly ConnectedAccount[]
): GroupedConnectedAccount[] =>
  groupAccountsByAddress(accounts.filter(({ address }) => isThor(address)));
